"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_1 = require("@vidazoo/ui");
var theme = require("./theme.scss");
var SettingRow_1 = require("../row/SettingRow");
var mobx_react_1 = require("mobx-react");
exports.notificationSettingsListHeaders = [{
        label: "Name",
        sortBy: "name",
        searchKey: "name"
    }, {
        label: "Application",
        sortBy: "app",
        searchKey: "app"
    }, {
        label: "Notification",
        sortBy: "notification",
    }, {
        label: "Email",
        sortBy: "email",
    }, {
        label: "Sms",
        sortBy: "sms",
    }, {
        label: "Created Date",
        sortBy: "created",
        searchKey: "created",
    }, {
        label: "Last sent",
        sortBy: "lastSent",
        searchKey: "lastSent",
    }, {
        label: "Actions",
    }];
var List = /** @class */ (function (_super) {
    tslib_1.__extends(List, _super);
    function List(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.renderHeaderAndFooter = function (scrollTop, scrollLeft, columnsWidth, setFreezeColumn, freezeColumnIndex) {
            var _a = _this.props, sortDirection = _a.sortDirection, onSearch = _a.onSearch, sortBy = _a.sortBy, onSort = _a.onSort, searchQueries = _a.searchQueries;
            return (React.createElement(ui_1.DataGridRow, { columnsWidth: columnsWidth }, exports.notificationSettingsListHeaders.map(function (header) {
                var props = {
                    blue: true,
                    label: header.label,
                    sortable: !!header.sortBy,
                    sortBy: header.sortBy,
                    sortActive: sortBy === header.sortBy,
                    searchKey: header.searchKey,
                    searchable: !!header.searchKey,
                    searchQuery: searchQueries[header.searchKey || ""],
                    freezeColumnIndex: freezeColumnIndex,
                    columnsWidth: columnsWidth,
                    setFreezeColumn: setFreezeColumn,
                    sortDirection: sortDirection,
                    onSort: onSort,
                    onSearch: onSearch,
                };
                return (React.createElement(ui_1.DataGridHeaderColumn, tslib_1.__assign({}, props)));
            })));
        };
        _this.onColumnResize = function (columnsWidth) {
            _this.props.setColumnsWidth(columnsWidth);
        };
        _this.renderRow = function (index, viewportIndex, columnsWidth, freezeColumnIndex) {
            var _a = _this.props, items = _a.items, onDelete = _a.onDelete, sortBy = _a.sortBy, updateSetting = _a.updateSetting, phone = _a.phone;
            var item = items[index];
            return (React.createElement(SettingRow_1.default, { key: item._id, setting: item, sortBy: sortBy, onDelete: onDelete, columnsWidth: columnsWidth, freezeColumnIndex: freezeColumnIndex, index: index, updateSetting: updateSetting, phone: phone }));
        };
        return _this;
    }
    List.prototype.render = function () {
        var _a = this.props, items = _a.items, getColumnsWidth = _a.getColumnsWidth;
        var columnsWidth = getColumnsWidth();
        return (React.createElement(ui_1.DataGrid, { onColumnResize: this.onColumnResize, className: theme.list, extraData: items, headersCount: exports.notificationSettingsListHeaders.length, itemsCount: items.length, renderRow: this.renderRow, rowHeight: 40, columnsWidth: columnsWidth, renderHeader: this.renderHeaderAndFooter }));
    };
    List = tslib_1.__decorate([
        mobx_react_1.observer
    ], List);
    return List;
}(React.Component));
exports.default = List;
